import { Typography } from '@mui/material';

interface PercentCaptionProps {
  /** Whole percent, 0-100. */
  percent: number;
}

/**
 * Raw percentage next to a title or band label. No progress bars anywhere in
 * the ledger — inline bars made row heights ragged and band bars read as noise.
 */
export const PercentCaption = ({ percent }: PercentCaptionProps) => (
  <Typography
    component="span"
    variant="caption"
    color="text.secondary"
    noWrap
    sx={{ fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}
  >
    {percent}%
  </Typography>
);
